export const getBrowserInfo = () => {
  try {
    const ua = navigator.userAgent || "";

    let name = "Unknown";
    let version = "";

    const ver = (re: RegExp) => {
      const m = ua.match(re);
      return m ? m[1] : "";
    };

    if (/edg\/([\d.]+)/i.test(ua) || /edge\/([\d.]+)/i.test(ua)) {
      name = "Edge";
      version = ver(/edg\/([\d.]+)/i) || ver(/edge\/([\d.]+)/i);
    } else if (/opr\/([\d.]+)/i.test(ua)) {
      name = "Opera";
      version = ver(/opr\/([\d.]+)/i);
    } else if (/samsungbrowser\/([\d.]+)/i.test(ua)) {
      name = "Samsung Internet";
      version = ver(/samsungbrowser\/([\d.]+)/i);
    } else if (/crios\/([\d.]+)/i.test(ua)) {
      name = "Chrome (iOS)";
      version = ver(/crios\/([\d.]+)/i);
    } else if (/fxios\/([\d.]+)/i.test(ua)) {
      name = "Firefox (iOS)";
      version = ver(/fxios\/([\d.]+)/i);
    } else if (/firefox\/([\d.]+)/i.test(ua)) {
      name = "Firefox";
      version = ver(/firefox\/([\d.]+)/i);
    } else if (/chrome\/([\d.]+)/i.test(ua) && !/(edg|opr|samsungbrowser)\//i.test(ua)) {
      name = "Chrome";
      version = ver(/chrome\/([\d.]+)/i);
    } else if (/version\/([\d.]+).*safari/i.test(ua)) {
      name = "Safari";
      version = ver(/version\/([\d.]+)/i);
    } else if (/safari\/([\d.]+)/i.test(ua)) {
      name = "Safari";
      version = ver(/safari\/([\d.]+)/i);
    }

    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
    const legacyMode = isMobile && (name === "Chrome" || name === "Chrome (iOS)");

    return {
      name,
      version,
      language: navigator.language,
      cookies: navigator.cookieEnabled ? "Enabled" : "Disabled",
      mobile: isMobile,
      legacyMode
    };
  } catch {
    // Safe fallback if navigator is missing (SSR, bots, etc.)
    return {
      name: "Unknown",
      version: "",
      language: "en",
      cookies: "Unknown",
      mobile: false,
      legacyMode: false
    };
  }
};

